import BaseService from '../BaseService';

class AppInfoService {
    constructor(instance) {
        this.instance = instance;
        this.base = new BaseService(this.instance);
    }

    getMetascan = (params, headers) => {
        return this.base.get(`/appinfo/${params.hash}`, headers);
    }

    getNist = (params, headers) => {
        return this.base.get(`/appinfo/${params.hash}/nist`, headers);
    }

    getVulnerability = (params, headers) => {
        return this.base.get(`/vulnerability/${params.hash}`, headers);
    }
}

export default AppInfoService;
